var _style, _g, _path, _path2, _path3, _path4, _path5, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVeterinaryClinicAidKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "80px",
    height: "80px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#7A7A69;}\t.st1{fill:#AED45B;}\t.st2{fill:#9AC932;}\t.st3{fill:#FFFFFF;}\t.st4{fill:#FCB74F;}\t.st5{fill:#161345;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160,112c-4.4,0-8-3.6-8-8V56c0-4.4,3.6-8,8-8s8,3.6,8,8v48C168,108.4,164.4,112,160,112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,112c-4.4,0-8-3.6-8-8V56c0-4.4,3.6-8,8-8s8,3.6,8,8v48C360,108.4,356.4,112,352,112z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472,96H40c-22.1,0-40,17.9-40,40v336c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V136 C512,113.9,494.1,96,472,96z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M472,96H40c-22.1,0-40,17.9-40,40v152h472c8.8,0,16,7.2,16,16v168c0,22.1-17.9,40-40,40h24 c22.1,0,40-17.9,40-40V136C512,113.9,494.1,96,472,96z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472,96H40c-22.1,0-40,17.9-40,40v136h512V136C512,113.9,494.1,96,472,96z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312,160h-32v-32c0-4.4-3.6-8-8-8h-32c-4.4,0-8,3.6-8,8v32h-32c-4.4,0-8,3.6-8,8v32c0,4.4,3.6,8,8,8h32v32 c0,4.4,3.6,8,8,8h32c4.4,0,8-3.6,8-8v-32h32c4.4,0,8-3.6,8-8v-32C320,163.6,316.4,160,312,160z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152,56h208V24c0-13.3-10.7-24-24-24H176c-13.3,0-24,10.7-24,24V56z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M168,272H88v32c0,4.4,3.6,8,8,8h64c4.4,0,8-3.6,8-8V272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M424,272h-80v32c0,4.4,3.6,8,8,8h64c4.4,0,8-3.6,8-8V272z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,386.2c-31.1,0-56.4,25.3-56.4,56.4c0,28.5,21.1,45.5,56.4,45.5s56.4-17,56.4-45.5  C312.4,411.5,287.1,386.2,256,386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.1,380.7c13,0,23.6-10.6,23.6-23.6c0-11.9-9.2-29.1-23.6-29.1s-23.6,17.2-23.6,29.1  C201.5,370.1,212.1,380.7,225.1,380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.9,380.7c13,0,23.6-10.6,23.6-23.6c0-11.9-9.2-29.1-23.6-29.1c-14.4,0-23.6,17.2-23.6,29.1  C263.3,370.1,273.9,380.7,286.9,380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M335.6,368c-14.4,0-23.6,17.2-23.6,29.1c0,13,10.6,23.6,23.6,23.6c13,0,23.6-10.6,23.6-23.6  C359.3,385.2,350.1,368,335.6,368z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200,397.1c0-11.9-9.2-29.1-23.6-29.1s-23.6,17.2-23.6,29.1c0,13,10.6,23.6,23.6,23.6S200,410.1,200,397.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeterinaryClinicAidKit);
export default __webpack_public_path__ + "static/media/veterinary-clinic-aid-kit.df323e5425a89828caa88900b2e720fa.svg";
export { ForwardRef as ReactComponent };